export class Feedback {
  name: string;
  playAgain: boolean;
  moreGameModes: boolean;
  moreChallengingQuestions: boolean;
  text: string;
}
